import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IZCValidationTableResult } from 'src/app/interfaces/zc-validation-result.interface';
import * as _ from 'lodash';

@Component({
    standalone: false,
    selector: 'zc-validation-result',
    templateUrl: './zc-validation-result.component.html',
    styleUrls: ['./zc-validation-result.component.scss']

})
export class ZCValidationResultComponent implements OnInit {
    _ = _;

    constructor(@Inject(MAT_DIALOG_DATA) public data: IZCValidationTableResult) {}

    ngOnInit(): void {}
}
